import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constant} from '../util/constant';
import {catchError, retry} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class DischargeService {
    httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

    constructor(private httpClient: HttpClient) {
    };

    deleteByIdDischarge(dischargeId): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'Discharge/deleteDischarge', {'dischargeId': dischargeId}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    countDischarge(discharge): Observable<number> {
        return this.httpClient.post<number>(Constant.BASE_URL + 'Discharge/count', {'discharge': discharge}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    updateDischarge(discharge, refData): Observable<string> {
        return this.httpClient.post<string>(Constant.BASE_URL + 'Discharge/updateDischarge', [discharge, refData], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    addDischarge(discharge, refData): Observable<string> {
        return this.httpClient.post<string>(Constant.BASE_URL + 'Discharge/addDischarge', [discharge, refData], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    findAllDischarge(discharge, pageNo: number, itemsPerPage: number): Observable<string[]> {
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'Discharge/findAllDischarge',
            {'discharge': discharge, 'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}}, this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

    // custom service for global search

    globalSearchCount(searchTerm,appointmentId,expertId,patientId): Observable<number> {
        return this.httpClient.post<number>(
            Constant.BASE_URL + 'Discharge/countGlobalDischarge',
            {'searchTerm': searchTerm,'appointmentId':appointmentId,'expertId':expertId,'patientId':patientId},
            this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

    globalSearchFind(searchTerm,appointmentId,expertId,patientId, pageNo: number, itemsPerPage: number): Observable<string[]> {
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'Discharge/findGlobalDischarge',
            {'searchTerm': searchTerm,'appointmentId':appointmentId,'expertId':expertId,'patientId':patientId,
                'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}},
            this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

}
